import styled from "styled-components";
import {GAMBLING_SESSION_LIMITS_RESPONSIBLE_GAMING_LINK} from "../css-constants";

export const RegulatoryTextBox = styled.div`
  color: ${props => props.theme.colors.textMiddleDark};
  font-size: 1.3rem;
  white-space: pre-line;
  padding-top: 15px;
  
  
  > .${GAMBLING_SESSION_LIMITS_RESPONSIBLE_GAMING_LINK} {
    color: ${props => props.theme.colors.brandPrimary};
    text-decoration-line: underline;
  }
`